import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []

  toggleLanguage(event) {
    const selectedLanguage = event.target.value
    const groups = this.element.querySelectorAll('.card-group-extended__group')

    groups.forEach(group => {
      const lang = group.dataset.language
      group.classList.toggle('is-hidden', lang !== selectedLanguage)
      this.element.setAttribute('lang', selectedLanguage)
    })


  }
}
